export const NAVIGATION_ITEMS = [
  { key: "/", label: "Home" },
  { key: "/education", label: "Education" },
  { key: "/experience", label: "Experience" },
  { key: "/skills", label: "Skills" },
  { key: "/projects", label: "Projects" },
  { key: "/research", label: "Research" },
  { key: "/about", label: "About Me" },
];
